<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-18 14:42:21
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-10-31 18:00:54
 * @FilePath: \ioc_base\src\modules\workshopEmergencyHandle\view\emergencyHandle.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="emergencyHandle section-main__warp">
    <ioc-table
      ref="crud"
      :data="processList"
      :option="option"
      :page="page"
      @search-change="query"
      @search-reset="reset"
      @size-change="sizeChange"
      @current-change="pageChange"
      @selection-change="handleSelectChange"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          class="iss-operation-button"
          icon="el-icon-plus"
          @click="addProcess"
          v-auth="'/workshop/emergency-handle:add'"
          >{{ $t("emergencyHandle.button.add") }}</el-button
        >
        <el-button
          type="primary"
          class="iss-operation-button"
          icon="el-icon-delete"
          v-auth="'/workshop/emergency-handle:delete'"
          @click="batchDelete"
          >批量删除</el-button
        >
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-Detail"
            @click="() => checkProcess(scope.row.handleProcessCode)"
          ></el-button>
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('emergencyHandle.button.edit')"
          placement="top-start"
        >
          <el-button
            type="text"
            icon="iconfont icon-xiugai pointer"
            v-auth="'/workshop/emergency-handle:update'"
            @click="() => editProcess(scope.row.handleProcessCode)"
          ></el-button>
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('emergencyHandle.button.delete')"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="el-icon-delete pointer"
            v-auth="'/workshop/emergency-handle:delete'"
            @click="() => deleteProcess([scope.row.handleProcessCode])"
          >
          </el-button>
        </el-tooltip>
      </template>
    </ioc-table>
    <process-add ref="addProcess" @save-success="getProcessList"></process-add>
  </div>
</template>

<script>
import ProcessAdd from "../components/emergencyProcessModal";
import tableOption from "../const/emergencyHandleTable";
import appPanel from "@src/components/business/app-panel/index.vue";
import api from "../api";
export default {
  components: {
    ProcessAdd
    // appPanel
  },
  data() {
    return {
      btnLoading: false,
      queryForm: {},
      option: tableOption(this),
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      processList: [],
      handleProcessName: ""
    };
  },
  mounted() {
    this.getProcessList();
  },
  methods: {
    reset() {
      this.queryForm = {};
      this.page.pageSize = 10;
      this.page.currentPage = 1;
      this.getProcessList();
    },
    query(param) {
      this.page.currentPage = 1;
      this.queryForm = Object.assign({}, param);
      this.getProcessList();
    },
    // 获取批量删除勾选的值
    handleSelectChange(v) {
      this.codes = v.map((item) => item.handleProcessCode);
    },
    // 分页
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getProcessList();
    },
    // 分页
    pageChange(pageNo) {
      this.page.currentPage = pageNo;
      this.getProcessList();
    },
    // 添加流程
    addProcess() {
      this.$router.push({
        path: "/workshop/emergency-process-crud",
        query: { type: 1 }
      });
      // this.$refs.addProcess.toggleVisible(1);
    },
    // 批量删除流程
    async batchDelete() {
      if (!this.codes || !this.codes.length) {
        return this.$message.warning("请选择要删除的流程");
      }
      this.deleteProcess(this.codes);
    },
    // 获取流程列表
    async getProcessList() {
      const { currentPage, pageSize } = this.page;
      const params = {
        // handleProcessName: this.handleProcessName,
        ...this.queryForm,
        pageNum: currentPage,
        pageSize
      };
      // const loading = this.$loading({
      //   lock: true,
      //   text: "请求中",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)"
      // });

      try {
        const { success, returnObj } = await this.$fetch(
          api.queryEmergencyHandleProcessList,
          params
        );
        if (success) {
          // setTimeout(() => {
          //   loading.close();
          // }, 500);
          this.processList = returnObj.list;
          this.page.total = returnObj.total;
        }
      } catch (error) {
        // setTimeout(() => {
        //   loading.close();
        // }, 500);
        console.error(error);
      }
    },
    // 编辑流程
    async editProcess(handleProcessCode, type = 2) {
      this.$router.push({
        path: "/workshop/emergency-process-crud",
        query: { type, id: handleProcessCode }
      });
    },
    // 删除流程
    async deleteProcess(codes) {
      try {
        const confirm = await this.$confirm("确定删除该处置流程吗?", {
          title: "删除确认"
        });
        if (!confirm) return;
        const { success, msgContent } = await this.$fetch(
          api.deleteEmergencyHandleProcess,
          {
            handleProcessCodeList: codes
          }
        );
        if (success) {
          this.getProcessList();
        } else {
          msgContent && this.$message.warning(msgContent);
        }
      } catch (error) {
        console.error(error);
      }
    },
    // 查看流程详情
    checkProcess(handleProcessCode) {
      this.editProcess(handleProcessCode, 3);
    }
  }
};
</script>

<style lang="scss" scoped>
.emergencyHandle {
  // width: 100%;
  display: flex;
  flex-direction: column;
  // padding: 0 10px;
  .addProcess {
    padding: 10px 0;
    border-bottom: 1px solid #3e5574;
  }
  .filterProcess {
    margin: 10px 0;
  }
  .processTable {
    flex: 1;
  }
  .page-comp {
    margin: 10px 0;
  }
}
</style>
